import React from 'react';

const ProblemSection = () => {
  return (
    <section className="py-24 px-6 bg-white" id="problem">
      <div className="max-w-[960px] mx-auto">
        <div className="flex flex-col gap-6 mb-16 text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#050B15] leading-tight">
            Internal controls look fine — until you're asked to prove they work.
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-16">
          <div className="p-8 rounded-xl border border-gray-100 bg-white shadow-sm hover:shadow-md transition-all relative overflow-hidden group flex flex-col h-full">
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#22C55E] group-hover:h-2 transition-all"></div>
            <div className="mb-4">
              <span className="material-symbols-outlined text-[#22C55E] text-3xl">folder_off</span>
            </div>
            <h3 className="text-lg font-bold text-[#050B15] mb-3 leading-tight">Evidence scattered</h3>
            <p className="text-sm text-gray-600 leading-relaxed flex-grow">Critical documentation is buried across disconnected silos and personal drives.</p>
          </div>
          <div className="p-8 rounded-xl border border-gray-100 bg-white shadow-sm hover:shadow-md transition-all relative overflow-hidden group flex flex-col h-full">
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#FFD100] group-hover:h-2 transition-all"></div>
            <div className="mb-4">
              <span className="material-symbols-outlined text-[#FFD100] text-3xl">schedule</span>
            </div>
            <h3 className="text-lg font-bold text-[#050B15] mb-3 leading-tight">Manual collation</h3>
            <p className="text-sm text-gray-600 leading-relaxed flex-grow">Teams waste weeks manually pulling together samples and proof for auditors.</p>
          </div>
          <div className="p-8 rounded-xl border border-gray-100 bg-white shadow-sm hover:shadow-md transition-all relative overflow-hidden group flex flex-col h-full">
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#F87171] group-hover:h-2 transition-all"></div>
            <div className="mb-4">
              <span className="material-symbols-outlined text-[#F87171] text-3xl">error</span>
            </div>
            <h3 className="text-lg font-bold text-[#050B15] mb-3 leading-tight">Inconsistent evidence</h3>
            <p className="text-sm text-gray-600 leading-relaxed flex-grow">Lack of standards leads to "good enough" proof that fails under deep scrutiny.</p>
          </div>
          <div className="p-8 rounded-xl border border-gray-100 bg-white shadow-sm hover:shadow-md transition-all relative overflow-hidden group flex flex-col h-full">
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#0077C8] group-hover:h-2 transition-all"></div>
            <div className="mb-4">
              <span className="material-symbols-outlined text-[#0077C8] text-3xl">question_mark</span>
            </div>
            <h3 className="text-lg font-bold text-[#050B15] mb-3 leading-tight">Difficult explanations</h3>
            <p className="text-sm text-gray-600 leading-relaxed flex-grow">Difficulty translating technical control data into Board-level assurance.</p>
          </div>
        </div>
        <div className="bg-gray-50 p-8 rounded-xl border-l-4 border-[#F87171]">
          <p className="text-xl font-bold text-[#050B15] text-center italic">
            "The result is audit stress, repeated findings, board exposure, and wasted senior finance time."
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
